import Crud from '@/stores/crudBase';
import api from '@/apis/fixedAsset/fAIncrementDecrementAPI.js';
var crud = new Crud('fAIncrement', api);

const state = {
  ...crud.state,
  _config: {
    table: 'fa_increment_decrement',
    field: {
      key: 'ref_id',
      code: 'ref_no',
      posted: 'is_posted',
    },
  },
};
const getters = {
  ...crud.getters,
};
const actions = {
  ...crud.actions,
};
const mutations = {
  ...crud.mutations,
};

export default {
  debug: process.env.NODE_ENV !== 'production',
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
